import './FilteredActionListLoaders-6f14c45b.css';

var classes = {"LoadingSkeleton":"prc-FilteredActionList-LoadingSkeleton-x9WXt"};

export { classes as default };
